import { Dispatch, FC, SetStateAction } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../../../../../_metronic/helpers'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  totalsData: {
    TotalReservasCamaEnEstadoAsignado: number
    TotalReservasCamaEnEstadoGenerado: number
    TotalReservasCamaAEliminar: number
  } | null
  onAccept: () => void
}

const ModalListNoShow: FC<Props> = ({ show, setShow, totalsData, onAccept }) => {
  const handleClose = () => {
    setShow(false)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Reservas a Cancelar</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {totalsData ? (
            <div className='d-flex flex-column gap-5'>
              <div className='d-flex justify-content-between align-items-center'>
                <span className='fs-5 fw-semibold'>Reservas Cama Asignado:</span>
                <span className='fs-4 fw-bold text-primary'>
                  {totalsData.TotalReservasCamaEnEstadoAsignado}
                </span>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className='fs-5 fw-semibold'>Reservas Cama Generado:</span>
                <span className='fs-4 fw-bold text-primary'>
                  {totalsData.TotalReservasCamaEnEstadoGenerado}
                </span>
              </div>
              <div className='d-flex justify-content-between align-items-center'>
                <span className='fs-5 fw-semibold'>Total Reservas Camas a cancelar:</span>
                <span className='fs-4 fw-bold text-primary'>
                  {totalsData.TotalReservasCamaAEliminar}
                </span>
              </div>
            </div>
          ) : (
            <div className='text-center p-10'>
              <p className='fs-4'>No hay reservas por cancelar</p>
            </div>
          )}
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={handleClose}>
            Cerrar
          </button>
          {totalsData && (
            <button type='button' className='btn btn-primary' onClick={onAccept}>
              Aceptar
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export { ModalListNoShow }
